import emailjs from "@emailjs/browser";
import { getVisitorInfo } from "./utm";

const TO_EMAIL = "hirensurani1997@gmail.com";

const DEFAULTS = {
  serviceId: "service_o34ynb7",
  templateId: "template_qcjiedg",
  publicKey: "PqVAEdM4Cdl1b5Z4y",
};

function resolveEnv(value, fallback) {
  const raw = String(value || "").trim();
  if (!raw) return fallback;
  // .env.example placeholders must not override real defaults
  if (/^your_/i.test(raw) || /your_(service|template|public)/i.test(raw)) {
    return fallback;
  }
  return raw;
}

export function getEmailJsConfig() {
  return {
    serviceId: resolveEnv(process.env.REACT_APP_EMAILJS_SERVICE_ID, DEFAULTS.serviceId),
    templateId: resolveEnv(process.env.REACT_APP_EMAILJS_TEMPLATE_ID, DEFAULTS.templateId),
    publicKey: resolveEnv(process.env.REACT_APP_EMAILJS_PUBLIC_KEY, DEFAULTS.publicKey),
  };
}

/**
 * Shared EmailJS send used by Let’s Connect and the chat lead flow.
 */
export async function sendContactEmail({
  name,
  email,
  phone = "",
  company = "",
  message,
  source = "portfolio-contact",
}) {
  const { serviceId, templateId, publicKey } = getEmailJsConfig();
  const visitorInfo = getVisitorInfo();

  const templateParams = {
    from_name: name,
    from_email: email,
    phone: phone || "Not provided",
    company: company || "Not provided",
    message: message,
    to_email: TO_EMAIL,
    email: TO_EMAIL,
    utm_source: visitorInfo.utm_source || "Direct",
    utm_medium: visitorInfo.utm_medium || source,
    utm_campaign: visitorInfo.utm_campaign || "None",
    referrer: visitorInfo.referrer || "Direct",
    timestamp: new Date().toLocaleString(),
  };

  try {
    const result = await emailjs.send(serviceId, templateId, templateParams, publicKey);
    return { success: true, result };
  } catch (error) {
    return {
      success: false,
      error: error?.text || error?.message || "Email send failed",
    };
  }
}
